import React from 'react';
import { FormattedMessage } from 'react-intl';

import { translations } from '@/locale';

import Table from '@flyblack/common/components/Table';
import Typography from '@flyblack/common/components/Typography';

export interface Props {}

const PushNotificationsTableHeader: React.FC<Props> = () => {
  const text = translations.pages.notifications.table.header;

  return (
    <Typography is={Table.Header} type="hummingbird" className="uppercase text-opacity-[64%] justify-between font-bold">
      <Table.Data className="pr-1 w-[80%]" header>
        <FormattedMessage id={text.content} />
      </Table.Data>

      <Table.Data className="pr-1 w-[15%] justify-end" header>
        <FormattedMessage id={text.sentAt} />
      </Table.Data>
    </Typography>
  );
};

export default PushNotificationsTableHeader;
